import Layout from '../components/Layout.jsx'
import { DataTable } from '../components/DataTable.jsx'
import { useApp } from '../context/AppContext.jsx'
import { getTimeline } from '../db/api.js'
import { useApiData } from '../hooks/useApiData.js'

function formatDateTime(value) {
  if (!value) return '-'
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return value
  return date.toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

function shortText(value, limit = 90) {
  if (!value) return '-'
  if (value.length <= limit) return value
  return `${value.slice(0, limit - 1)}...`
}

export default function Timeline() {
  const { period } = useApp()
  const { data, loading, error } = useApiData(
    () => getTimeline(period.start, period.end),
    [period.start, period.end],
    { initialData: [] }
  )

  const columns = [
    {
      key: 'date',
      label: 'Data',
      width: 180,
      render: (value) => formatDateTime(value),
    },
    {
      key: 'title',
      label: 'Evento',
      width: 220,
    },
    {
      key: 'desc',
      label: 'Descricao',
      render: (value) => shortText(value, 110),
    },
    {
      key: 'accountName',
      label: 'Conta',
      width: 220,
      render: (value) => value || '-',
    },
    {
      key: 'userEmail',
      label: 'Usuario',
      width: 220,
      render: (value) => value || '-',
    },
  ]

  return (
    <Layout
      breadcrumb={[{ label: 'Historico' }]}
      title="Historico de Alteracoes"
      showPeriod
    >
      <div className="section-card">
        <div className="sc-head">
          <div className="card-title-group">
            <span className="t-label">Linha do tempo</span>
            <span className="t-title" style={{ fontSize: 17 }}>
              Alteracoes recentes do Google Ads
            </span>
          </div>
          <span className="badge badge-neutral">
            {period.start} ate {period.end}
          </span>
        </div>

        <div style={{ padding: '0 24px 24px' }}>
          {error ? (
            <div className="empty" style={{ padding: 32 }}>
              <div className="empty-title">Nao foi possivel carregar o historico</div>
              <div className="empty-desc">{error}</div>
            </div>
          ) : (
            <DataTable
              columns={columns}
              data={data || []}
              loading={loading}
              emptyText="Nenhuma alteracao encontrada para o periodo selecionado"
              pagination
              pageSize={12}
              striped={false}
            />
          )}
        </div>
      </div>
    </Layout>
  )
}
